//Loads only those fees for the current logged in portal user
define(function () {
	var Backbone = require('backbone');
	const IpsModelCollection = require('civicsBase/ipsModelCollection');
	const urlBuilder = require('civicsUtils/buildUrlParameters');

	return IpsModelCollection.extend({
		unpaidOnly: false,
		//https://civics-test.inforlocal.com:8443/delegate/civics-api/api/cdr/common/fees?ExtendedFilter=[{operator:And,criteria:[{operator:Equal,property:Fee.PortalProject.ApplicationKey,Value:8182}]
		urlRoot: 'delegate/civics-api/api/cdr/common/',
		url: function () {
			var ret = null;

			if (this.isPortalProject === true) {
				ret = this.urlRoot + 'fees';
			} else {
				ret = this.commonID ? this.urlRoot + 'applications/{0}/fees'.format(this.commonID) :null;
			}

			if (this.urlParameters) {
				ret += urlBuilder.buildUrlParameters(this.urlParameters)
			} 

			if (this.checkForMinimumFee) {
				if (ret.indexOf('?') >= 0) {
					ret += '&checkForMinimumFee=true';
				} else {
					ret += '?checkForMinimumFee=true';
				}
			}
 
			return ret;
		},
		parse: function (response) {
			this.responseStatus = response.responseStatus;
			let data = response.data;
			$.each(data, (index, fee) => {
				if (fee.feeGroupCode.trim() == "") {
					fee.feeGroupCode = '__generalFees';
					fee.feeGroupDescription = i18n.t('CIVICS.MY_FEES_LIST.LIST.GENERAL_FEES_GROUP');
				}
				if (fee.feeGroupDescription.trim() == "") {
					fee.feeGroupDescription = i18n.t('CIVICS.COMMON.VALUE_NOT_CONFIG');
				}
			})
			return data;
		},
	});
});
